/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConceptGraphOutput } from './conceptGraphOutput';
import type { ContentStudioQuestion } from './contentStudioQuestion';

/**
 * Output: The concept graph and initial scoping questions.
 */
export interface ContentStudioStage1Response {
  graph: ConceptGraphOutput;
  scopingQuestions: ContentStudioQuestion[];
  /** The AI's initial recommendation for scope */
  recommendedNodeIds: string[];
}
